import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

import { ToastConfigContext } from '@web/shared/ui/toast';

/**
 * Onde os toasts aparecem: embaixo, no centro, a 16px da borda, no máximo três de uma vez,
 * com 8px entre eles. O sonner cuida da fila, do tempo e do gesto de arrastar; o DESENHO é
 * o `Toast` (`toast.tsx`), montado por `toast.custom` — por isso `unstyled`.
 *
 * `dismissLabel` é o rótulo do botão × de todos os toasts: vem de quem monta o `Toaster`
 * (o app, com o dicionário), porque o design system não escolhe palavra.
 */
function Toaster({ dismissLabel, ...props }: ToasterProps & { dismissLabel: string }) {
  // O tema que está na tela (claro até a pessoa escolher o escuro), nunca o do sistema.
  const { resolvedTheme } = useTheme();
  const theme = resolvedTheme === 'dark' ? 'dark' : 'light';

  return (
    <ToastConfigContext.Provider value={{ dismissLabel }}>
      <Sonner
        theme={theme}
        position="bottom-center"
        offset={16}
        mobileOffset={16}
        gap={8}
        visibleToasts={3}
        className="toaster group"
        toastOptions={{ unstyled: true, classNames: { toast: 'flex justify-center' } }}
        // A modal open (Radix) turns the body's pointer events off; the toasts sit outside it
        // and their buttons (×, "Desfazer") must still take the click.
        style={{ '--width': '320px', pointerEvents: 'auto' } as React.CSSProperties}
        {...props}
      />
    </ToastConfigContext.Provider>
  );
}

export { Toaster };
